<template>
    <div class="container">
        <el-card class="box-card">
            <div slot="header" class="clearfix">
                <span class="h3 text-bold">Orden guardada con exito</span>
            </div>
            <div class="text-left" v-if="lastOrder && lastOrder.employee">
                <p class="text-bold lead">Fecha {{ lastOrder.date }}</p>

                <div class="table-responsive">
                    <table class="table table-striped">
                        <tr>
                            <th style="width: 50%">Cliente:</th>
                            <td>
                                {{ lastOrder.employee.profiles.first_name }}
                                {{ lastOrder.employee.profiles.first_surname }}
                                {{ lastOrder.employee.profiles.second_surname }}
                            </td>
                        </tr>
                        <tr>
                            <th>Email Empleado:</th>
                            <td>{{ lastOrder.employee.email }}</td>
                        </tr>
                        <tr>
                            <th>Monto Total:</th>
                            <td>{{ lastOrder.subtotal | currency }}</td>
                        </tr>
                    </table>
                </div>
            </div>
            <br />
            <div class="text-left">
                <button
                    class="btn btn-lg text-bold btn-primary btn-block"
                    type="submit"
                    @click.prevent="backToHome"
                >
                    Volver a vender
                </button>
            </div>
        </el-card>
    </div>
</template>

<script>
import { mapState } from "vuex";
import { OrderStore } from "../OrderStore";

export default {
    name: "home",
    computed: {
        ...mapState(["lastOrder"]),
    },
    methods: {
        backToHome() {
            this.$router.push("/");
            location.reload(true);
            OrderStore.Amount = "";
        },
    },
};
</script>
